var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.1,44.2h-45.5c-6.1,0-11.1,5-11.1,11.1v45.5c0,6.1,5,11.1,11.1,11.1h45.5c6.1,0,11.1-5,11.1-11.1v-45.5c0-6.1-5-11.1-11.1-11.1ZM49.3,55.4c0-3.5,2.8-6.3,6.3-6.3h45.5c3.5,0,6.3,2.8,6.3,6.3v26.9l-7.5-7.4c-1.8-1.8-4.4-2.7-6.9-2.4-2.5.3-4.8,1.7-6.1,3.9l-8.6,13.8c-.4.6-1.1.8-1.7.4l-7.6-4.2c-3.9-2.1-8.6-1-11.1,2.6l-8.4,12.4c0-.2,0-.4,0-.7v-45.5ZM101.1,107.1h-45.5c-1.3,0-2.5-.4-3.5-1l9.6-14.3c1.1-1.5,3.1-2,4.7-1.1l7.6,4.2c2.8,1.6,6.4.7,8.1-2.1l8.7-13.9c.6-.9,1.5-1.5,2.6-1.6,1.1-.1,2.2.2,2.9,1l10.9,10.8v11.7c0,3.5-2.8,6.3-6.3,6.3Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,31.5h-45.5c-4.1,0-7.9,2.2-9.8,5.9-.6,1.2-.2,2.7,1,3.3,1.2.6,2.7.2,3.3-1,1.1-2,3.2-3.3,5.5-3.3h45.5c3.5,0,6.3,2.8,6.3,6.3v45.5c0,2.3-1.3,4.4-3.3,5.6-1.2.6-1.6,2.1-1,3.3.4.8,1.3,1.3,2.1,1.3s.8,0,1.2-.3c3.6-2,5.9-5.7,5.9-9.8v-45.5c0-6.1-5-11.2-11.2-11.2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,76.6c5.7,0,10.3-4.6,10.3-10.3s-4.6-10.3-10.3-10.3-10.3,4.6-10.3,10.3,4.6,10.3,10.3,10.3ZM67.5,61c3,0,5.4,2.4,5.4,5.4s-2.4,5.4-5.4,5.4-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4Z",
    fill: "#A8A8A8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1,123.4h1.9l3.6,8.5v-8.5h2.2v14.9h-1.8l-3.6-8.9v8.9h-2.3v-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9,133.6v-5.6c0-3,1.1-4.8,4.3-4.8s4.3,1.8,4.3,4.8v5.6c0,3-1.1,4.9-4.3,4.9s-4.3-1.9-4.3-4.9ZM29.7,134.2v-6.8c0-1.2-.2-2.2-1.5-2.2s-1.5.9-1.5,2.2v6.8c0,1.2.2,2.2,1.5,2.2s1.5-1,1.5-2.2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,123.4h2.7v13h3.6v1.9h-6.3v-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2,133.6v-5.6c0-3,1.1-4.8,4.3-4.8s4.3,1.8,4.3,4.8v5.6c0,3-1.1,4.9-4.3,4.9s-4.3-1.9-4.3-4.9ZM52,134.2v-6.8c0-1.2-.2-2.2-1.5-2.2s-1.5.9-1.5,2.2v6.8c0,1.2.2,2.2,1.5,2.2s1.5-1,1.5-2.2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,133.4v-5c0-3.2,1-5.1,4.2-5.1s4.1,1.6,4.1,4.3v.8h-2.6v-.8c0-1.4-.1-2.3-1.5-2.3s-1.5,1.2-1.5,2.5v6.2c0,1.5.3,2.5,1.6,2.5s1.6-1,1.6-2.6v-1.4h-1.6v-1.7h4v7.5h-1.8l-.2-1.5c-.4,1-1.1,1.7-2.5,1.7-2.9,0-4-2-4-5.1Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,133.6v-5.6c0-3,1.1-4.8,4.3-4.8s4.3,1.8,4.3,4.8v5.6c0,3-1.1,4.9-4.3,4.9s-4.3-1.9-4.3-4.9ZM72.6,134.2v-6.8c0-1.2-.2-2.2-1.5-2.2s-1.5.9-1.5,2.2v6.8c0,1.2.2,2.2,1.5,2.2s1.5-1,1.5-2.2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,123.4h2.9l3,14.9h-2.5l-.6-3.4h-2.6l-.6,3.4h-2.6l3-14.9ZM86.5,133.1l-1-6.2-1,6.2h2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,123.4h2.4l2,10.5,1.9-10.5h2.4l-3,14.9h-2.7l-3-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,123.4h2.9l3,14.9h-2.5l-.6-3.4h-2.6l-.6,3.4h-2.6l3-14.9ZM104.5,133.1l-1-6.2-1,6.2h2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,123.4h2.7v14.9h-2.7v-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4,123.4h2.7v13h3.6v1.9h-6.3v-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.3,123.4h2.9l3,14.9h-2.5l-.6-3.4h-2.6l-.6,3.4h-2.6l3-14.9ZM126.8,133.1l-1-6.2-1,6.2h2Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,123.4h3.7c2.6,0,4.4.9,4.4,3.8s-.8,2.8-2.1,3c1.7.3,2.6,1.6,2.6,3.7s-1.4,4.3-4.1,4.3h-4.3v-14.9ZM135.3,129.5c1.6,0,2-.7,2-2.2s-.8-2-2.4-2h-.6v4.2h.9ZM135.4,136.4c1.7,0,2.1-.8,2.1-2.4s-.6-2.6-2.2-2.6h-1v5h1Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,123.4h2.7v13h3.6v1.9h-6.3v-14.9Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,123.4h6.2v1.9h-3.5v4.3h2.8v1.9h-2.8v4.9h3.6v1.9h-6.3v-14.9Z",
    fill: "#A8A8A8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/Company-logo.17f1ef236d87e1357d670bb394dc01cd.svg";
export { ForwardRef as ReactComponent };